"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = exports.PlayButtonComponent = exports.PauseButtonComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _reactPlayer = _interopRequireDefault(require("react-player"));

var _uiKit = require("@dbi-tools/ui-kit");

var _triangleRight = _interopRequireDefault(require("@dbi-tools/ui-kit/lib/icons/triangle-right"));

var _useMedia = require("../../hooks/use-media");

var _useRenditions = require("../../hooks/useRenditions");

var _types = require("../../types");

var _const = require("./const");

var _video = require("./video.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PauseButtonComponent = function PauseButtonComponent(_ref) {
  var _ref$isPlaying = _ref.isPlaying,
      isPlaying = _ref$isPlaying === void 0 ? false : _ref$isPlaying;
  return /*#__PURE__*/_react.default.createElement(_video.PauseButton, {
    color: "secondaryLight",
    variant: "link",
    visible: isPlaying
  }, /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 45.975 45.975",
    height: "1em"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.987,0c-2.762,0-5,2.239-5,5v35.975c0,2.763,2.238,5,5,5s5-2.238,5-5V5C18.987,2.238,16.75,0,13.987,0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.987,0c-2.762,0-5,2.239-5,5v35.975c0,2.762,2.238,5,5,5s5-2.238,5-5V5C36.987,2.239,34.749,0,31.987,0z"
  })), /*#__PURE__*/_react.default.createElement("span", null, "Pause"));
};

exports.PauseButtonComponent = PauseButtonComponent;

var PlayButtonComponent = function PlayButtonComponent(_ref2) {
  var _ref2$centered = _ref2.centered,
      centered = _ref2$centered === void 0 ? false : _ref2$centered,
      _ref2$isPlaying = _ref2.isPlaying,
      isPlaying = _ref2$isPlaying === void 0 ? false : _ref2$isPlaying,
      _ref2$mt = _ref2.mt,
      mt = _ref2$mt === void 0 ? 0 : _ref2$mt,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? null : _ref2$onClick;
  return /*#__PURE__*/_react.default.createElement(_video.PlayButton, {
    variant: "outlined",
    visible: !isPlaying,
    centered: centered,
    color: "secondaryLight",
    mt: mt,
    onClick: onClick,
    uppercase: true
  }, /*#__PURE__*/_react.default.createElement(_triangleRight.default, {
    measure: 12,
    color: "white",
    mr: 10
  }), /*#__PURE__*/_react.default.createElement("span", null, "play"));
};

exports.PlayButtonComponent = PlayButtonComponent;

var Video = function Video(_ref3) {
  var _ref3$cover = _ref3.cover,
      cover = _ref3$cover === void 0 ? false : _ref3$cover,
      preview = _ref3.preview,
      src = _ref3.src,
      onStart = _ref3.onStart,
      onReady = _ref3.onReady,
      otherProps = _objectWithoutProperties(_ref3, ["cover", "preview", "src", "onStart", "onReady"]);

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isPreviewloaded = _useState2[0],
      setIsPreviewloaded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVideoLoaded = _useState4[0],
      setIsVideoLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      sources = _useState6[0],
      setSources = _useState6[1];

  var _useState7 = (0, _react.useState)(preview),
      _useState8 = _slicedToArray(_useState7, 2),
      previewSrc = _useState8[0],
      setPreviewSrc = _useState8[1];

  var isLaptop = (0, _useMedia.useMedia)(_const.Breakpoints.LAPTOP);
  var isTablet = (0, _useMedia.useMedia)(_const.Breakpoints.TABLET);

  var _useInView = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true
  }),
      inView = _useInView.inView,
      ref = _useInView.ref;

  var path = _typeof(src) === 'object' ? src : [src];
  var soucesMD = (0, _useRenditions.useRenditions)({
    path: path,
    size: 'MD',
    type: _types.MediaTypes.VIDEO
  });
  var soucesSM = (0, _useRenditions.useRenditions)({
    path: path,
    size: 'SM',
    type: _types.MediaTypes.VIDEO
  });
  var isPlaying = otherProps.playing;

  var handleError = function handleError() {
    if (previewSrc === preview) {
      setIsPreviewloaded(false);
    } else {
      setPreviewSrc(preview);
    }
  };

  var setVideoLoadedState = function setVideoLoadedState() {
    if (!isVideoLoaded) setIsVideoLoaded(true);
  };

  var handleStart = function handleStart() {
    setVideoLoadedState();
    if (onStart) onStart();
  };

  var handleReady = function handleReady(player) {
    setVideoLoadedState();
    if (onReady) onReady(player);
  };

  (0, _react.useEffect)(function () {
    setPreviewSrc(preview);
  }, [preview]);
  (0, _react.useEffect)(function () {
    if (inView && isPlaying || !preview) {
      if (isLaptop) {
        setSources([{
          src: soucesMD,
          type: 'video/mp4',
          media: _useRenditions.VideoRenditionMediaString.MD
        }]);
      } else if (isTablet) {
        setSources([{
          src: soucesSM,
          type: 'video/mp4',
          media: _useRenditions.VideoRenditionMediaString.SM
        }]);
      } else {
        setSources([{
          src: src,
          type: "video/".concat(src && src.split('.').slice(-1)[0])
        }]);
      }
    }
  }, [inView, preview, isPlaying, src]);
  var isPreloaderShown = (isPlaying || !preview) && !isVideoLoaded;
  return /*#__PURE__*/_react.default.createElement(_video.VideoWrapper, {
    cover: cover,
    ref: ref
  }, inView && /*#__PURE__*/_react.default.createElement(_reactPlayer.default, _extends({
    forcevideo: "true",
    url: sources,
    onReady: handleReady,
    onStart: handleStart
  }, otherProps)), isPreloaderShown && /*#__PURE__*/_react.default.createElement(_uiKit.Loading, {
    color: "gray800",
    type: "spinner",
    fontSize: 32,
    full: false
  }), preview && inView && isPreviewloaded && /*#__PURE__*/_react.default.createElement(_video.Preview, {
    visible: !isPlaying,
    src: previewSrc,
    onError: handleError,
    alt: "Video preview"
  }));
};

exports.Video = Video;